import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReportSubscription } from 'src/shared/models/subscriptions.model';

@Injectable({
    providedIn: 'root'
})
export class DeleteSubscriptionService {
    private modalData: SubscriptionOptions = null;

    constructor(
        private modalService: NgbModal,
    ) { }

    public openModal(options: SubscriptionOptions, modalComponent: Type<any>): NgbModalRef {
        if (!options || typeof options !== "object")
            throw "Options argument is required";
        
        this.modalData = options;

        const modalRef = this.modalService.open(modalComponent, {
            animation: true,
            backdrop: 'static',
            backdropClass: 'stopScrolling',
            size: 'lg'
        });

        return modalRef;
    }

    public _getModalData(): SubscriptionOptions {
        let modalData = this.modalData;
        this.modalData = null;
        return modalData;
    }
}

export interface SubscriptionOptions {
    embedMode: boolean,
    reportType: number,
    subscriptionId: number,
    existingSchedule?: ReportSubscription,
    subscriptionTitle: string,
    relatedId: number,
    dashboardKey: string, 
}